import { render, staticRenderFns } from "./ProjectNum.vue?vue&type=template&id=0159c5ef&scoped=true"
import script from "./ProjectNum.vue?vue&type=script&lang=js"
export * from "./ProjectNum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0159c5ef",
  null
  
)

export default component.exports